module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#rain",
      toString: function () {
        return this.url;
      }
    }